import { render, staticRenderFns } from "./AttributeMessage.vue?vue&type=template&id=65c80a36&"
import script from "./AttributeMessage.vue?vue&type=script&lang=js&"
export * from "./AttributeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports